import {Box, Button, Typography} from "@material-ui/core";
import * as React from "react";
import './Dashboard.css'
import {Grid} from "@mui/material";

import {Pagination} from "@material-ui/lab";
import {useEffect, useRef, useState} from "react";
import CustomTable from "../../component/customTable/CustomTable";
import {convertCurrencyFormat, convertCurrencyFormatPositiveNegative} from "../../utils/numberConvertor";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {DashboardService} from "./DashboardService";

import cash from "./image/user.svg"
import {CashGroupService} from "../CashGroups/CashGroupService";
import moment from "jalali-moment";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import useDraggableScroll from "use-draggable-scroll";


const Dashboard = () => {
    //drag-start
    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});
    //drag-end
    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new DashboardService(fundID, token, snackbar, loading)
    const groupService = new CashGroupService(fundID, token, snackbar, loading)

    const [pageCount, setPageCount] = useState(5);
    const [groupsList, setGroupsList] = useState([]);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDashboardInfo()
        }
    }, [])


    useEffect(() => {
        if (typeof groupService !== "undefined") {
            getGroupInfoFromServer()
        }
    }, [])

    function getGroupInfoFromServer() {
        groupService.getCashGroupsList(fundID, page)
            .then(response => {
                // setItemCount(groupData.numberOfItems)
                setPageCount(response.totalPage)
                setGroupsList([])

                response.data.map((item, index) => {
                    setGroupsList((prevState => [...prevState,
                        prepareGroupsJsonList(
                            item.id,
                            (page * 20) + index + 1,
                            item.code,
                            item.name,
                            item.summationOfDepositAccountsBalance,
                            item.numberOfDepositAccounts,
                            item.summationOfLoans,
                            item.numberOfLoans,
                            item.numberOfMembers,
                            item.createdAt,
                            item.enabled
                        )
                    ]))
                })
            }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت خلاصه وضعیت گروه های صندوق"))
        })
    }

    function getDashboardInfo() {
        loading(setLoadingStateDispatch(true))
        service.getDashboardInfo(fundID)
            .then(response => {
                loading(setLoadingStateDispatch(false))
                setDashboardGlobalInfo(response.globalInfo)
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت خلاصه وضعیت صندوق", snackbar, loading)
        })
    }

    function setDashboardGlobalInfo(globalInfo) {
        setCashBalance(globalInfo.cashBalance)
        setTotalAmount(globalInfo.totalBalance)
        setTotalLoanAmount(globalInfo.totalLoanAmount)
        setCountOfGroup(globalInfo.countOfGroup)
        setCountOfMember(globalInfo.countOfMember)
        setCountOfLoans(globalInfo.countOfLoan)
        setUnionTotalBalance(globalInfo.unionTotalBalance)

    }


    const handleChange = (event, value) => {
        page = value - 1
        getGroupInfoFromServer()
    };


    const showEventsContent = (rowId) => {

    }

    const [welcomeMessage, setWelcomeMessage] = useState("");

    const [totalAmount, setTotalAmount] = useState("");
    const [cashBalance, setCashBalance] = useState("");
    const [countOfGroup, setCountOfGroup] = useState("");
    const [countOfMember, setCountOfMember] = useState("");
    const [totalLoanAmount, setTotalLoanAmount] = useState("");
    const [countOfLoans, setCountOfLoans] = useState("");
    const [unionTotalBalance, setUnionTotalBalance] = useState("");

    useEffect(() => {
        setWelcomeMessageBySystemTime();
    }, [])

    function setWelcomeMessageBySystemTime() {
        const today = new Date();
        const time = parseInt(today.getHours().toString())
        if (time > 18 || time < 7) {
            setWelcomeMessage("شب بخیر")
        } else if (time >= 7 && time < 11) {
            setWelcomeMessage("صبح بخیر")
        } else if (time >= 11 && time <= 13) {
            setWelcomeMessage("ظهر بخیر")
        } else if (time > 13 && time <= 18) {
            setWelcomeMessage("عصر بخیر")
        }
    }

    return (
        <section className="pageContainer">
            <Box className="d-flex flex-row w-100"
                 sx={{
                     margin: '1rem 0 1.2rem 0',
                     justifyContent: 'center',
                     alignContent: 'center',
                     alignItems: 'center'
                 }}>
                <section className='d-flex flex-column flex-nowrap flex-grow-1'
                         style={{alignItems: 'baseline'}}>
                    <Typography variant={"h5"}>
                        {welcomeMessage}
                    </Typography>
                </section>
            </Box>

            <section className="asset-container hideScroll" ref={ref} onMouseDown={onMouseDown}>
                <section className="asset-content-division">
                    <span className="asset-title">موجودی کل</span>
                    <span className="asset-details"
                          dir="ltr">{convertCurrencyFormatPositiveNegative(totalAmount)}</span>
                    <span className="asset-currency">ریال</span>
                </section>

                <section className="asset-content-division">
                    <span className="asset-title">مجموع پس انداز</span>
                    <span className="asset-details">{convertCurrencyFormatPositiveNegative(cashBalance)}</span>
                    <span className="asset-currency">ریال</span>
                </section>

                <section className="asset-content-division">
                    <span className="asset-title">موجودی اتحادیه</span>
                    <span className="asset-details">{convertCurrencyFormatPositiveNegative(unionTotalBalance)}</span>
                    <span className="asset-currency">ریال</span>
                </section>

                <section className="asset-content-division">
                    <span className="asset-title">تعداد وام ها</span>
                    <span className="asset-details">{convertCurrencyFormatPositiveNegative(countOfLoans)}</span>
                    <span className="asset-currency">عدد</span>
                </section>

                <section className="asset-content-division">
                    <span className="asset-title">مجموع وام ها</span>
                    <span className="asset-details">{convertCurrencyFormatPositiveNegative(totalLoanAmount)}</span>
                    <span className="asset-currency">ریال</span>
                </section>

                <section className="asset-content-division">
                    <span className="asset-title">تعداد اعضا</span>
                    <span className="asset-details">{convertCurrencyFormat(countOfMember)}</span>
                    <span className="asset-currency">عضو</span>
                    <img src={cash} alt="" className="imgIcon"/>
                </section>

            </section>
            <section className='flex-grow-1 d-flex flex-column' style={{overflowY: 'hidden'}}>

                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-row flex-nowrap flex-grow-1'
                             style={{alignItems: 'baseline'}}>
                        <Typography variant={"h5"}>
                            خلاصه وضعیت صندوق
                        </Typography>

                    </section>
                </Box>

                <CustomTable
                    header={columns}
                    data={groupsList}
                    rowClicked={showEventsContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </section>
    )
}
export default Dashboard;

const columns = [
        {
            id: 'number',
            label: '#',
            align: 'right',
        },
        {
            id: 'code',
            label: 'کد',
            align: 'right',
        },
        {
            id: 'name',
            label: 'نام',
            align: 'right',
        },
        {
            id: 'cash',
            label: 'موجودی (ریال)',
            align: 'right',
        },
        {
            id: 'numberOfLoans',
            label: 'تعداد وام ها',
            align: 'right',
        },
        {
            id: 'loanAmount',
            label: 'مجموع وام ها (ریال)',
            align: 'right',
        },
        {
            id: 'userCount',
            label: 'اعضا',
            align: 'right',
        },
        {
            id: 'numberOfDepositAccounts',
            label: 'تعداد حساب ها',
            align: 'right',
        },
        {
            id: 'createdDate',
            label: 'تاریخ ساخت',
            align: 'right',
        },
        {
            id: 'state',
            label: 'وضعیت',
            align: 'right',
        },
    ]
;


function prepareGroupsJsonList(
    id, itemID, code, name, inventory, numberOfDepositAccounts,
    summationOfLoans, numberOfLoans, numberOfMembers, createdDate, enabled) {
    return {
        id: id,
        number: itemID,
        code: code,
        name: name,
        loanAmount: summationOfLoans ? convertCurrencyFormat(summationOfLoans) : "0",
        numberOfLoans: numberOfLoans ? convertCurrencyFormat(numberOfLoans) : "0",
        numberOfDepositAccounts: numberOfDepositAccounts ? convertCurrencyFormat(numberOfDepositAccounts) : "0",
        userCount: numberOfMembers ? convertCurrencyFormat(numberOfMembers) : "0",
        cash: convertCurrencyFormat(inventory),
        createdDate: moment(createdDate, 'YYYY-M-D')
            .locale('fa')
            .format('YYYY/M/D'),
        state: enabled ?
            <span className="bg_active_state">فعال</span> :
            <span className="bg_deActive_state">غیرفعال</span>,
    };
}